import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=ad7c55d2&"
import script from "./NavHeader.vue?vue&type=script&lang=js&"
export * from "./NavHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ad7c55d2', component.options)
    } else {
      api.reload('ad7c55d2', component.options)
    }
    module.hot.accept("./NavHeader.vue?vue&type=template&id=ad7c55d2&", function () {
      api.rerender('ad7c55d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/nav/NavHeader.vue"
export default component.exports